module.exports = __webpack_public_path__ + "img/tips5@x2.5de86cc7.png";